type Props = {
  className?: string;
  fill?: string;
};

export const FinecoPaperClipIcon: React.FC<Props> = ({ className, fill = '#1C2226' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <g clipPath="url(#clip0_1602_3924)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 22.5C15.255 22.5 18 19.6694 18 16.0424V6.62712C18 4.28719 16.2344 2.5 14.1875 2.5C12.1406 2.5 10.375 4.28719 10.375 6.62712V16.0424C10.375 17.0952 11.1613 17.839 12 17.839C12.8387 17.839 13.625 17.0952 13.625 16.0424V6.16102C13.625 5.60873 14.0727 5.16102 14.625 5.16102C15.1773 5.16102 15.625 5.60873 15.625 6.16102V16.0424C15.625 18.0786 14.0607 19.839 12 19.839C9.93926 19.839 8.375 18.0786 8.375 16.0424V6.62712C8.375 3.30382 10.9186 0.5 14.1875 0.5C17.4564 0.5 20 3.30382 20 6.62712V16.0424C20 20.6528 16.477 24.5 12 24.5C7.52299 24.5 4 20.6528 4 16.0424V6.16102C4 5.60873 4.44772 5.16102 5 5.16102C5.55229 5.16102 6 5.60873 6 6.16102V16.0424C6 19.6694 8.74499 22.5 12 22.5Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1602_3924">
          <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
